var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1851 6.67889C15.0268 4.6793 12.8619 3.33398 10.3823 3.33398C7.57094 3.33398 5.16405 5.06344 4.17028 7.51512M14.1505 7.51512H17.5V4.17021M4.64823 13.3687C5.80651 15.3683 7.97144 16.7136 10.451 16.7136C13.2624 16.7136 15.6693 14.9842 16.6631 12.5325M6.68283 12.5325H3.33333V15.8774",
    stroke: "#616874",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncRefresh);
export default __webpack_public_path__ + "static/media/syncRefresh.c5b74cbf52e33ee5fa2e3d546de12541.svg";
export { ForwardRef as ReactComponent };